import { Stack } from '@mantine/core'
import { IconThumbUp } from '@tabler/icons-react'
import { observer } from 'mobx-react-lite'

import { Screen } from '@/components/Screen'

import { FeedbackTable } from './FeedbackScreen/FeedbackTable'

export const FeedbackScreen = observer(function FeedbackScreen() {
  return (
    <Screen title="Feedback" icon={IconThumbUp}>
      <Stack gap="md">
        <FeedbackTable />
      </Stack>
    </Screen>
  )
})
